import { Button, HFlow, Icon, Theme, Tooltip, useTheme } from 'bold-ui'
import { css } from 'emotion'
import { ArquivoTemporarioStatusEnum } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

const NAO_EXISTEM_DADOS_TEXT = 'Não existem dados para geração do relatório'
const EM_PROCESSAMENTO_TEXT = 'Relatório em processamento'
const IVCF_NO_PDF_E_CSV_TEXT =
  'O PDF e CSV exibe as informações do IVCF-20 da pessoa idosa, inclusive pontuação e dimensões alteradas.'

interface RelatoriosButtonGroupProps {
  hasIvcfFilter?: boolean
  shouldRefetch: boolean
  isAcompanhamentoCondicoesSaude: boolean
  statusRelatorio: ArquivoTemporarioStatusEnum
  numberOfElements: number
  otherButtons?: React.ReactNode
  onClickExportarCSV?: () => void
  onClickExportarPDF?: () => void
}

export function RelatoriosButtonGroup(props: Readonly<RelatoriosButtonGroupProps>) {
  const {
    hasIvcfFilter,
    shouldRefetch,
    statusRelatorio,
    numberOfElements,
    otherButtons,
    onClickExportarCSV: exportarCSV,
    onClickExportarPDF: exportarPDF,
  } = props

  const theme = useTheme()
  const classes = styles(theme)

  if (!exportarPDF && !exportarCSV && !otherButtons) {
    return null
  }

  const hasResults = numberOfElements > 0
  const hasOtherButtons = !isUndefinedOrNull(otherButtons)

  const isRelatorioProcessando = shouldRefetch || statusRelatorio === ArquivoTemporarioStatusEnum.EM_PROCESSAMENTO

  const mensagemTooltipCsvAndPdf = isRelatorioProcessando
    ? EM_PROCESSAMENTO_TEXT
    : !hasResults
    ? NAO_EXISTEM_DADOS_TEXT
    : null

  const shouldDisableCsvAndPdf = !hasResults || isRelatorioProcessando

  return (
    <HFlow justifyContent={hasOtherButtons ? 'space-between' : 'flex-end'} hSpacing={0}>
      {hasOtherButtons && otherButtons}
      <HFlow justifyContent='flex-end' alignItems='center'>
        {hasIvcfFilter && (
          <Tooltip text={IVCF_NO_PDF_E_CSV_TEXT}>
            <Icon icon='infoCircleFilled' size={1} style={classes.infoIcon} />
          </Tooltip>
        )}
        {exportarCSV && (
          <Tooltip text={mensagemTooltipCsvAndPdf}>
            <Button onClick={exportarCSV} disabled={shouldDisableCsvAndPdf}>
              Exportar CSV
            </Button>
          </Tooltip>
        )}
        {exportarPDF && (
          <Tooltip text={mensagemTooltipCsvAndPdf}>
            <Button kind='primary' onClick={exportarPDF} disabled={shouldDisableCsvAndPdf}>
              <HFlow hSpacing={0.5}>
                <Icon icon='fileWithItemsOutline' />
                Imprimir
              </HFlow>
            </Button>
          </Tooltip>
        )}
      </HFlow>
    </HFlow>
  )
}

const styles = (theme: Theme) => ({
  infoIcon: css`
    &:hover {
      fill: ${theme.pallete.primary.main};
      cursor: pointer;
    }
  `,
})
